import * as types from './mutation-types'

export default {
  [types.SET_TEMPLATES] (state, payload) {
    state.templates = payload.data
    state.pagination = { total: payload.total, current_page: payload.current_page }
  },
  [types.SET_TEMPLATE] (state, payload) {
    state.template = payload
  },
  [types.SET_BLOCKS] (state, payload) {
    state.blocks = payload || []
  },
  [types.ADD_BLOCK] (state, { block, index }) {
    if (index !== undefined && index >= 0) {
      state.blocks.splice(index, 0, block)
    } else {
      state.blocks.push(block)
    }
  },
  [types.UPDATE_BLOCK] (state, { id, data }) {
    var idx = state.blocks.findIndex(function (b) { return b._id === id })
    if (idx !== -1) {
      state.blocks.splice(idx, 1, Object.assign({}, state.blocks[idx], data))
    }
  },
  [types.REMOVE_BLOCK] (state, id) {
    state.blocks = state.blocks.filter(function (b) { return b._id !== id })
    if (state.selectedBlockId === id) state.selectedBlockId = null
  },
  [types.SET_SELECTED_BLOCK] (state, id) {
    state.selectedBlockId = id
  },
  [types.SET_LOADING] (state, payload) {
    state.loading = payload
  },
  [types.SET_SAVING] (state, payload) {
    state.saving = payload
  },
  [types.SET_DIRTY] (state, payload) {
    state.dirty = payload
  },
  [types.SET_REFERENCE_DATA] (state, payload) {
    if (payload.groups !== undefined) state.groups = payload.groups
    if (payload.tags !== undefined) state.tags = payload.tags
  }
}
